/* eslint-disable react-i18n/no-dynamic-translation-keys */
import React from "react";

import * as SC from "./PrintMessage.styled";
import { useTranslation } from "react-i18next";

const PrintMessage = ({ title = "", content = "" }) => {
  const { t } = useTranslation();

  return (
    <SC.PrintMessageWrapper>
      <SC.Title>{t([title])}</SC.Title>
      <SC.Content>{t([content])}</SC.Content>
    </SC.PrintMessageWrapper>
  );
};

export default PrintMessage;
